import {Component, Injector} from "@angular/core";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {AssessmentItem} from "@models";

export interface DialogData_AssessmentItemProcedureAndReasoningDialogInput extends MatDialogDataBaseInput {
	item: AssessmentItem;
}

@Component({
	selector: "sim-assessment-item-hints-dialog",
	templateUrl: "./assessment-item-procedure-and-reasoning-dialog.component.html",
	styleUrl: "./assessment-item-procedure-and-reasoning-dialog.component.scss",
	standalone: false,
})
export class AssessmentItemProcedureAndReasoningDialogComponent extends BasicMaterialDialog<
	AssessmentItemProcedureAndReasoningDialogComponent,
	DialogData_AssessmentItemProcedureAndReasoningDialogInput
> {
	constructor(_injector: Injector) {
		super(_injector);
	}
}
